import { DocumentNode, gql } from '@apollo/client';
import { StackProps, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { ResourceCarousel } from '@/components/ResourceCarousel';

import { ImageDisplay_CommentEmbeddedImageFragment } from './graphql-types/ImageDisplay_CommentEmbeddedImageFragment';

import { Images } from './components/Images';

export const ImageDisplay: React.FC<
  {
    commentEmbeddedImage?: ImageDisplay_CommentEmbeddedImageFragment[];
  } & StackProps
> & {
  commentEmbeddedImageFragment: DocumentNode;
} = ({ commentEmbeddedImage = [], ...stackProps }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [currentSlide, setCurrentSlide] = React.useState(0);

  const onClickImage = async (index: number): Promise<void> => {
    setCurrentSlide(index);
    onOpen();
  };

  return (
    <>
      <Images
        urls={commentEmbeddedImage
          .map(
            (embeddedImage) => embeddedImage.commentEmbeddedImageProxyThumbnail
          )
          .filter((url): url is string => !!url)}
        onClickImage={onClickImage}
        {...stackProps}
      />
      <ResourceCarousel
        isOpen={isOpen}
        onClose={onClose}
        slides={commentEmbeddedImage.map((embeddedImage) => {
          return {
            id: embeddedImage.imageId,
            imageProxy:
              embeddedImage.commentEmbeddedImageProxyFullSize ?? undefined,
          };
        })}
        currentSlide={currentSlide}
      />
    </>
  );
};
ImageDisplay.commentEmbeddedImageFragment = gql`
  fragment ImageDisplay_CommentEmbeddedImageFragment on CommentEmbeddedImage {
    imageId
    commentEmbeddedImageProxyThumbnail: imageProxy(input: { h: 200 })
    commentEmbeddedImageProxyFullSize: imageProxy(input: {})
  }
`;
